import React, { Component } from 'react';

import {
    Spin,
    Card,
    Statistic,
    Input,
    Button,
    Timeline,
    message,
} from 'antd';

import { SettingOutlined, ArrowDownOutlined, FileDoneOutlined,  } from '@ant-design/icons';

import favicon from './favicon.png';

class Onboarding extends Component {
    state = {
        apiKey: null,
    }

    saveApiKey = () => {
        const { apiKey } = this.state;
        console.log('saving api key', apiKey);
        this.props.saveApiKey(apiKey);
    }

    render() {
        const { apiKey } = this.state;
        const { loading } = this.props;
        return (
            <Card 
                title={<div style={{ textAlign: 'center' }}>Welcome to AMZ Watcher</div>}
                actions={[<div style={{ textAlign: 'center', fontSize: 12  }}><a href="https://amzwatcher.com/knowledge-base/#wordpress-plugin" target="_blank" style={{ color: 'grey', textDecoration: 'underline' }}>How to get an API Key</a></div>]}
                style={{ width: '500px', margin: '30px auto 0 auto', }}>
                <p>Checking your site for broken Amazon links is easy. Just follow these steps to generate your first site report:</p>
                <br />
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Timeline>
                        <Timeline.Item dot={<img src={favicon} style={{ height: 23 }} />}>
                            Create a free account on <a href="https://app.amzwatcher.com/sign-up/" target="_blank">amzwatcher.com</a>
                        </Timeline.Item>
                        <Timeline.Item dot={<FileDoneOutlined style={{ fontSize: '18px' }} />}>
                            Add your website as a project
                        </Timeline.Item>
                        <Timeline.Item dot={<SettingOutlined style={{ fontSize: '18px' }} />}>
                            Copy the site's API key from the site's settings
                        </Timeline.Item>
                        <Timeline.Item dot={<ArrowDownOutlined style={{ fontSize: '18px' }} />}>
                            Paste the API key down below and click Let's go
                        </Timeline.Item>
                    </Timeline>
                </div>
                <div style={{ textAlign: 'center', marginTop: '-25px' }}>
                    <div style={{ marginBottom: 10 }}>Your API Key</div>
                    <div>
                        <Input value={apiKey} onChange={(e) => this.setState({ apiKey: e.target.value })} style={{ marginBottom: 10, width: 300 }} />
                    </div>
                    <Button type="primary" onClick={this.saveApiKey} loading={loading}>Let's go!</Button>
                </div>
            </Card>
        );
    }
}

export default Onboarding;